<template>
  <div>
    <b-modal
      id="reset-password-modal"
      ref="reset-password-modal-ref"
      hide-footer
      title="FORGOTTEN YOUR PASSWORD?"
    >
      <b-form
        class="login-form"
        @submit.stop.prevent="onSubmit"
      >
        <div class="vtd-card-block">
          <h5 class="vtd-card-title">
            We will send you an email to reset your password.
          </h5>
          <!-- <FlashMessage /> -->
          <b-form-group
            label="Email"
            label-for="input-email"
            class="vtd-form-group"
          >
            <b-form-input
              id="input-email"
              v-model.trim="$v.form.email.$model"
              type="text"
              class="vtd-form-control vtd-form-control-lg "
              :state="validateState('email')"
            />
          </b-form-group>

          <div class="btn-container">
            <b-button 
              type="submit"
              class="vtd-btn vtd-btn-success vtd-btn-login vtd-btn-xl vtd-btn-block vtd-btn-center vtd-text-white btn-reset"
            >
              Reset
            </b-button>

            <b-button 
              type="button"
              class="vtd-btn vtd-btn-success vtd-btn-login vtd-btn-xl vtd-btn-block vtd-btn-center vtd-text-white btn-cancel"
              @click="()=>{hideModal()}"
            >
              Cancel
            </b-button>
          </div>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { required, email } from 'vuelidate/lib/validators'
// import FlashMessage from "@/partials/flash-message"

export default {
  components: {
    // FlashMessage
  },
  data() {
    return {
      form: {
        email: '',
      }
    }
  },
  validations: {
    form: {
      email: {
        required, email
      },
    }  
  },
  computed: {
   
  },
  
  methods: {
    showModal() {
      this.$refs['reset-password-modal-ref'].show()
    },
    hideModal() {
      this.$refs['reset-password-modal-ref'].hide()
    },
    
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      await this.resetPassword(
        this.form.email
      )
      this.resetRememberMe();
      this.hideModal()
    }, 
    ...mapActions({
      resetPassword: 'auth/resetPasswordAction',
      resetRememberMe: 'auth/resetRememberMeAction'
    }),
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    }
  }
};
</script>

<style scoped lang="scss">
  .btn-container {
    display: flex;
  }

  .btn-reset {
    background-color: #629dd3;
    margin: 0;
    margin-right: 5px;
  }

  .btn-cancel {
    background-color: #fcb134;
    margin: 0;
  }
</style>
